import routes from '@config/routes';
import withAuthGuard from '@hocs/withAuthGuard';

import SignUpPage from './SignUpPage';

export default withAuthGuard({
  condition: { isAuth: false },
  redirectTo: routes.HOME,
})(SignUpPage);
